<template>
  <div class="report-open-content">
    <div class="select-time clear-fix">
      <div class="query-total">
        <el-date-picker v-model="timeSlotValue" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="changeTimeSlot" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <!-- <div class="query-btn">查询</div> -->
      <div class="query-bill-btn" @click="queryBillButton">查看每日详情</div>
      <!-- <div class="query-bill-data-btn">查看球台开单数据</div> -->
    </div>
    <div class="report-content" v-if="!isShowInfo">
      <div class="report-left" v-if="loading_left">
        <div class="first-floor crossing blue">今日访客：{{ returnData.visitorCount }}人<span class="small-size">详细资料去访客功能查看</span></div>
        <div class="first-floor crossing red pointer" @click="showDrawer(0)">总营业额：￥{{ totalTurnover.toFixed(2) }}</div>
        <div class="first-floor crossing orange pointer" @click="closeInfo">
          实际收入：￥{{ realIncome.toFixed(2) }}<span>{{ realNumber }}单</span></div>
        <div class="report-left-flex">
          <div class="report-left-left">
            <div class="crossing brown pointer" @click="showDrawer(1)">
              球台：￥{{ tableIncome.toFixed(2) }}
              <span>
                {{ tableNumber }}单
              </span>
            </div>
            <div class="crossing brown pointer" @click="showDrawer(2)">
              商品：￥{{ goodsIncome.toFixed(2) }}
              <span>
                {{ goodsNumber }}单
              </span>
            </div>
            <div class="crossing brown pointer" @click="showDrawer(3)">
              充值：￥{{ returnData.billiardsStatementAccountTotalDetailed.vipAmount.toFixed(2) }}
              <span>
                {{ returnData.billiardsStatementAccountTotalDetailed.vipCount }}单
              </span>
            </div>
            <div class="crossing brown" @click="showDrawer(4)">
              报名：￥{{ returnData.billiardsStatementAccountTotalDetailed.signAmount.toFixed(2) }}
              <span>
                {{ returnData.billiardsStatementAccountTotalDetailed.signCount }}单
              </span>
            </div>
            <div class="crossing brown" @click="showDrawer(5)">
              预定：￥{{ returnData.billiardsStatementAccountTotalDetailed.reserveAmount.toFixed(2) }}
              <span>
                {{ returnData.billiardsStatementAccountTotalDetailed.reserveCount }}单
              </span>
            </div>
            <div class="crossing brown" @click="showDrawer(6)">
              助教：￥0.00
              <span>
                0单
              </span>
            </div>
          </div>
          <div class="report-left-right">
            <div class="crossing brown">
              储存柜：￥{{ returnData.billiardsStatementAccountTotalDetailed.cabinetAmount.toFixed(2) }}
              <span>{{ returnData.billiardsStatementAccountTotalDetailed.cabinetCount }}单</span>
            </div>
            <div class="crossing brown" @click="showDrawer(7)">
              娃娃机：￥{{ returnData.billiardsStatementAccountTotalDetailed.toyAmount.toFixed(2) }}
              <span>{{ returnData.billiardsStatementAccountTotalDetailed.toyCount }}单</span>
            </div>
            <div class="crossing brown">
              贩卖机：￥{{ returnData.billiardsStatementAccountTotalDetailed.waterAmount.toFixed(2) }}
              <span>{{ returnData.billiardsStatementAccountTotalDetailed.waterCount }}单</span>
            </div>
            <div class="crossing brown">
              唱歌机：￥0.00
              <span>0单</span>
            </div>
            <div class="crossing brown">
              V R 机：￥0.00
              <span>0单</span>
            </div>
            <div class="crossing brown">
              飞镖机：￥0.00
              <span>0单</span>
            </div>
          </div>
        </div>
        <div class="first-floor crossing yellow pointer" @click="showDrawer(0)">
          虚收营业：￥{{ grossIncome.toFixed(2) }}
          <span>{{ grossNumber }}单</span>
        </div>
        <div class="first-floor crossing green">
          会员结账：￥{{ returnData.billiardsStatementAccountTotalDetailed.otherAmount.toFixed(2) || 0 }}
          <span>{{ returnData.billiardsStatementAccountTotalDetailed.otherCount || 0 }}单</span>
        </div>
        <div class="first-floor crossing green">
          免单金额：￥{{ returnData.billiardsStatementAccountTotalDetailed.freeSheetAmount.toFixed(2) }}
          <span>{{ returnData.billiardsStatementAccountTotalDetailed.freeSheetCount }}单</span>
        </div>
        <div class="first-floor crossing last-item green">
          销账金额：￥{{ returnData.billiardsStatementAccountTotalDetailed.writeOffAmount.toFixed(2) }}
          <span>{{ returnData.billiardsStatementAccountTotalDetailed.writeOffCount }}单</span>
        </div>
        <div class="first-floor crossing white" style="color:#FF7200;">
          追单金额：￥{{ returnData.billiardsStatementAccountTotalDetailed.chasingListAmount.toFixed(2) }}
          <span>{{ returnData.billiardsStatementAccountTotalDetailed.chasingListCount }}单</span>
        </div>
        <div class="first-floor crossing white" style="color:#FF2F2F;">
          退单金额：￥0.00
          <span>0单</span>
        </div>
      </div>
      <!-- <router-view /> -->
      <div class="report-right" v-if="isDrawer < 0">
        <div class="report-right-top" v-if="tableData.length > 0" @mouseover="addShadow" @click="clickList">
          <i ref="shadow" class="add-shadow"></i>
          <i ref="columnShadow" class="column-shadow"></i>
          <div class="report-title">{{ sameTime }}实收业绩表：￥{{ tableData.allAllIncome.toFixed(2) }}</div>
          <div class="report-surface-header">
            <div class="yellow-green">
              <p></p>
              <p></p>
              <p>日期</p>
            </div>
            <div class="yellow-green">
              <p></p>
              <p></p>
              <p>周期</p>
            </div>
            <div class="bright-red move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allToltalAmount.toFixed(2) }}</p>
              <p>总营业额</p>
            </div>
            <div class="fluorescein move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allAllIncome.toFixed(2) }}</p>
              <p>实际收入</p>
            </div>
            <div class="emerald-green move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allOnLineIncome.toFixed(2) }}</p>
              <p>线上收入</p>
            </div>
            <div class="blue move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allUnLineIncome.toFixed(2) }}</p>
              <p>线下收入</p>
            </div>
            <div class="yellow move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allRealIncome.toFixed(2) }}</p>
              <p>球台</p>
            </div>
            <div class="pink move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allGoodsIncome.toFixed(2) }}</p>
              <p>商品</p>
            </div>
            <div class="wathet move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allVipAmount.toFixed(2) }}</p>
              <p>充值</p>
            </div>
            <div class="green move-shadow">
              <p>当月统计</p>
              <p>￥{{ tableData.allWaterAmount.toFixed(2) }}</p>
              <p>自助商品</p>
            </div>
            <!-- <div class="pink">
              <p>当月统计</p>
              <p>￥{{tableData.allSignIncome.toFixed(2)}}</p>
              <p>报名</p>
            </div> -->
            <!-- <div class="green">
              <p>当月统计</p>
              <p>{{tableData.allTotalcount}}</p>
              <p>日访客</p>
            </div> -->
          </div>
          <div class="report-surface">
            <el-scrollbar ref="scrollbar" style="height: calc(100% - 2px)">
              <ul class="report-surface-list">
                <i class="add-li-shadow" ref="liShadow"></i>
                <li :class="item.bg_color ? 'bg_item1' : 'bg_item2'" v-for="(item, index) in tableData" :key="index">
                  <p class="yellow-green move-shadow">{{ item.day }}</p>
                  <p class="yellow-green move-shadow">{{ item.dateDay }}</p>
                  <p class="bright-red move-shadow">￥{{ item.totalAmount.toFixed(2) }}</p>
                  <p class="fluorescein move-shadow">￥{{ item.allIncome.toFixed(2) }}</p>
                  <p class="emerald-green move-shadow">￥{{ item.onLineIncome.toFixed(2) }}</p>
                  <p class="blue move-shadow">￥{{ item.unLineIncome.toFixed(2) }}</p>
                  <p class="move-shadow yellow">￥{{ item.realIncome.toFixed(2) }}</p>
                  <p class="move-shadow pink">￥{{ item.goodsIncome.toFixed(2) }}</p>
                  <p class="move-shadow wathet">￥{{ item.vipAmount.toFixed(2) }}</p>
                  <!-- <p class="wathet">￥{{item.reserveAmount.toFixed(2)}}</p>
                  <p class="pink">￥{{item.signAmount.toFixed(2)}}</p> -->
                  <p class="green move-shadow">￥{{ item.waterAmount.toFixed(2) }}</p>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </div>
        <div class="report-right-bottom">
          <statistics-echarts :data="statisticsData" :date="dateList" :name="name"></statistics-echarts>
        </div>
      </div>
      <div class="report-right" v-if="isDrawer >= 0">
        <component :is="currentName" @closeInfo="closeInfo" :timeSlotValue="timeSlotValue" v-if="isDrawer >= 0">
        </component>
        <!-- <report-table></report-table> -->
      </div>
    </div>
    <look-every-day-info v-if="isShowInfo" class="look-every-day-info" @showInfocb="showInfocb" :timeSlotValue="timeSlotValue"></look-every-day-info>
  </div>
</template>

<script>
import statisticsEcharts from './open/statisticsEcharts.vue'  //统计图表
import reportTable from './open/reportTable.vue'  //球桌详情
import reportGoods from './open/reportGoods.vue'  //商品详情
import reportChange from './open/reportChange.vue'//充值详情
import reportSign from './open/reportSign.vue'    //报名详情
import reportReserve from './open/reportReserve.vue'  //预定详情
import reportAssistant from './open/reportAssistant.vue'  //助教详情   暂无数据
import reportDoll from './open/reportDoll.vue'    //娃娃机
import totalTurnover from './open/totalTurnover'  //总营业额
import TotalItem from "./open/totalItem.vue";
import ItemInfo from "./open/itemInfo.vue";
import ItemTableInfo from "./open/itemTableInfo.vue";
import LookEveryDayInfo from "./open/lookEveryDayInfo.vue";
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
  data () {
    return {
      isShowInfo: false,
      visible: false,
      person: 0,
      middleNumber: 0,
      bottomNumber: 0,
      middleType: null,
      middleSingular: null,
      consumptionType: [],       //分类个数
      // middleExhibition: false,  //控制详细列表显示的开关
      // bottomExhibition: false,  //控制详细列表显示的开关
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      loading_left: false,//左侧报表数据防报错，请求到数据才加载
      timeSlotValue: [], //如果选择了时间
      tableData: [],  //报表累计信息列表
      totalAmountList: [],  //总营业额列表
      actualAmountList: [],  //实际收入列表
      onLineIncomeList: [],  //线上收入列表
      unLineIncomeList: [],  //线下收入列表
      tableIncomeList: [],  //球台收入列表
      goodsIncomeList: [],  //商品收入列表
      vipAmountList: [],  //充值收入列表
      waterIncomeList: [],  //水机收入列表
      dateList: [],   //日期列表
      statisticsData: [],  //给统计图表传入的数据
      name: '总营业额',
      sameTime: 0,//当前月份
      billiardsStatementAccountTotalDetailed: {},
      billiardsStatementAccountTotalGoodsList: {},
      //billiardsStatementRealTimeDto: {},
      //billiardsStatementAccountTotalDetailedDto: {},
      returnData: {},
      realOrderList: [],
      isDrawer: -1,
      currentName: 'reportTable',
      canRun: true,
    };
  },
  components: {
    TotalItem,
    ItemInfo,
    ItemTableInfo,
    LookEveryDayInfo,
    reportTable,  //球桌
    reportGoods,  //商品
    reportChange,  //充值
    reportSign,  //报名
    reportReserve,  //预定
    reportAssistant,  //助教
    totalTurnover,  //总营业额
    statisticsEcharts,   //统计图表
    reportDoll     //娃娃机
  },
  methods: {
    async goTo (item, index) {
      let bizContent = {};
      switch (item) {
        case 'fangke':
          bizContent.totalBizTypeEnum = "VISITOR"
          this.middleType = "访客人数"
          this.middleSingular = this.person + "人"
          break;
        case 'up':
          switch (index) {
            case 1:
              bizContent.totalBizTypeEnum = "TABLE"
              this.middleType = "球台"
              this.middleSingular = this.upTable[1].realAmount + "元" + " / " + this.upTable[1].realCount + "单"
              break;
            case 2:
              bizContent.totalBizTypeEnum = "STOCK"
              this.middleType = "商品"
              this.middleSingular = this.upTable[2].realAmount + "元" + " / " + this.upTable[2].realCount + "单"
              break;
            case 3:
              bizContent.totalBizTypeEnum = "VIP"
              this.middleType = "充值"
              this.middleSingular = this.upTable[3].realAmount + "元" + " / " + this.upTable[3].realCount + "单"
              break;
            case 4:
              bizContent.totalBizTypeEnum = "MATCH"
              this.middleType = "报名"
              this.middleSingular = this.upTable[4].realAmount + "元" + " / " + this.upTable[4].realCount + "单"
              break;
            case 5:
              bizContent.totalBizTypeEnum = "RESEV"
              this.middleType = "预定"
              this.middleSingular = this.upTable[5].realAmount + "元" + " / " + this.upTable[5].realCount + "单"
              break;
          }
          break;
        case 'middle':
          switch (index) {
            case 1:
              bizContent.totalBizTypeEnum = "VIP_CONSUMER"
              this.middleType = "会员消费"
              this.middleSingular = this.middleTable[1].realAmount + "元" + " / " + this.middleTable[1].realCount + "单"
              break;
          }
          break;
      }
      if (this.timeSlotValue.length == 2) {
        bizContent.beginDate = this.timeSlotValue[0];
        bizContent.endDate = this.timeSlotValue[1];
        bizContent.queryType = "MODEL";
      }
      if (bizContent.totalBizTypeEnum) {
        await response(requstsMethod.fun_Get_Api_Stock_Group_Type, bizContent)
          .then(data => {
            console.log(data, '报表数据01')
            this.consumptionType = data
          })
          .catch(err => {
            console.log(err)
          })
        this.middleExhibition = true
      }
    },
    mfun1 () {
      this.middleNumber = 0
    },
    mfun2 () {
      this.middleNumber = 1
    },
    mfun3 () {
      this.middleNumber = 2
    },
    bfun1 () {
      this.bottomNumber = 0
    },
    bfun2 () {
      this.bottomNumber = 1
    },
    bfun3 () {
      this.bottomNumber = 2
    },
    secondaryMenu () {

    },
    changeTimeSlot () {
      this.initData();
      //\"realPayDate\":[\"2019-12-18T09:00:01.000Z TO 2019-12-19T23:59:59.000Z\"]
      //this.parms.realPayDate="[\"2019-12-18T09:00:01.000Z TO 2019-12-19T23:59:59.000Z\"]"
    },
    queryBillButton () {
      this.isShowInfo = true;
    },
    clickQuestion () {
      //console.log("点击了question");
      this.visible = true;
    },
    questionMarkClose () {
      this.visible = false;
    },
    initData () {
      let bizContent = {};
      let monthBizContent = {};
      if (this.timeSlotValue) {
        bizContent.beginDate = this.timeSlotValue[0];
        bizContent.endDate = this.timeSlotValue[1];
      }
      let nowDate = new Date()
      let sameYear = nowDate.getFullYear()
      let sameMonth = nowDate.getMonth() + 1
      let sameDay = nowDate.getDate()
      if (sameMonth < 10) {
        sameMonth = "0" + sameMonth;
      }
      if (sameDay < 10) {
        sameDay = "0" + sameDay;
      }
      this.sameTime = sameYear + '-' + sameMonth
      monthBizContent.beginDate = sameYear + '-' + sameMonth + '-' + '01'
      monthBizContent.endDate = sameYear + '-' + sameMonth + '-' + sameDay
      //获取首页报表数据
      response(requstsMethod.fun_Get_Report_Order_Statistics, bizContent)
        .then(data => {
          console.log(data, '首页报表数据');
          this.returnData = data
          this.loading_left = true
          //console.log(data.billiardsStatementAccountTotalDetailed.realAmount,data.billiardsStatementAccountTotalDetailed.goodsAmount,data.billiardsStatementAccountTotalDetailed.vipAmount,data.billiardsStatementAccountTotalDetailed.signAmount,data.billiardsStatementAccountTotalDetailed.reserveAmount,data.billiardsStatementAccountTotalDetailed.realUnlineAmount,data.billiardsStatementAccountTotalDetailed.goodsUnlineAmount)
          // this.upTable[1].totalPrice = parseFloat(     //实际收入
          //   data.billiardsStatementAccountTotalDetailed.realAmount +     //球台收入
          //   data.billiardsStatementAccountTotalDetailed.goodsAmount +    //商品收入
          //   data.billiardsStatementAccountTotalDetailed.vipAmount +      //充值收入
          //   data.billiardsStatementAccountTotalDetailed.signAmount +     //报名收入
          //   data.billiardsStatementAccountTotalDetailed.reserveAmount +  //球台预定
          //   data.billiardsStatementAccountTotalDetailed.realUnlineAmount + //线下球桌金额
          //   data.billiardsStatementAccountTotalDetailed.goodsUnlineAmount  //酒水线下金额
          //   ).toFixed(2)
          // this.upTable[1].realCount=    //实际单数
          //   data.billiardsStatementAccountTotalDetailed.realCount +     //球桌结账笔数
          //   data.billiardsStatementAccountTotalDetailed.goodsCount +    //商品个数
          //   data.billiardsStatementAccountTotalDetailed.vipCount +      //会员充值笔数
          //   data.billiardsStatementAccountTotalDetailed.signCount +     //报名笔数
          //   data.billiardsStatementAccountTotalDetailed.reserveCount +  //预定条数
          //   data.billiardsStatementAccountTotalDetailed.realUnlineCount +//线下球桌单数
          //   data.billiardsStatementAccountTotalDetailed.goodsUnlineCount  //酒水线下单数
          if (!data.billiardsStatementAccountTotalDetailed.realUnlineAmount) {
            data.billiardsStatementAccountTotalDetailed.realUnlineAmount = 0
          }
          if (!data.billiardsStatementAccountTotalDetailed.goodsUnlineAmount) {
            data.billiardsStatementAccountTotalDetailed.goodsUnlineAmount = 0
          }
          if (!data.billiardsStatementAccountTotalDetailed.realUnlineCount) {
            data.billiardsStatementAccountTotalDetailed.realUnlineCount = 0
          }
          if (!data.billiardsStatementAccountTotalDetailed.goodsUnlineCount) {
            data.billiardsStatementAccountTotalDetailed.goodsUnlineCount = 0
          }
          //水机收入
          if (!data.billiardsStatementAccountTotalDetailed.waterAmount) {
            data.billiardsStatementAccountTotalDetailed.waterAmount = 0
          }
          //水机单数
          if (!data.billiardsStatementAccountTotalDetailed.waterCount) {
            data.billiardsStatementAccountTotalDetailed.waterCount = 0
          }
          this.billiardsStatementAccountTotalDetailed =
            data.billiardsStatementAccountTotalDetailed;
          this.billiardsStatementRealTimeDto =
            data.billiardsStatementRealTimeDto;

          this.table.list = [];
          this.table.realAmount =
            data.billiardsStatementAccountTotalDetailed.realAmount + data.billiardsStatementAccountTotalDetailed.realUnlineAmount;
          this.table.realCount =
            data.billiardsStatementAccountTotalDetailed.realCount + data.billiardsStatementAccountTotalDetailed.realUnlineCount;
          this.table.vipAmount =
            data.billiardsStatementAccountTotalDetailed.otherAmount;
          this.table.vipCount =
            data.billiardsStatementAccountTotalDetailed.otherCount;
          this.table.reserveAmount =
            data.billiardsStatementAccountTotalDetailed.reserveAmount;
          this.table.reserveCount =
            data.billiardsStatementAccountTotalDetailed.reserveCount;
          this.goods.list = [];
          this.goods.realAmount =
            data.billiardsStatementAccountTotalDetailed.goodsAmount + data.billiardsStatementAccountTotalDetailed.goodsUnlineAmount;
          this.goods.realCount =
            data.billiardsStatementAccountTotalDetailed.goodsCount + data.billiardsStatementAccountTotalDetailed.goodsUnlineCount;
          this.enter.list = [];
          this.enter.realAmount =
            data.billiardsStatementAccountTotalDetailed.signAmount;
          this.enter.realCount =
            data.billiardsStatementAccountTotalDetailed.signCount;
          this.vip.list = [];
          this.vip.realAmount =
            data.billiardsStatementAccountTotalDetailed.vipAmount;
          this.vip.realCount =
            data.billiardsStatementAccountTotalDetailed.vipCount;
          data.billiardsStatementAccountTotalGoodsList.forEach(item => {
            switch (item.goodsType) {
              case 0:
              case 3:
                item.goodsCountTitle = "结账单数";
                this.table.list.push(item);
                break;
              case 4:
                item.goodsCountTitle = "结账单数";
                this.enter.list.push(item);
                break;
              case 5:
                item.goodsCountTitle = "结账单数";
                this.vip.list.push(item);
                break;
              default:
                item.goodsCountTitle = "销售数量";
                this.goods.list.push(item);
                break;
            }
          });
        })
        .catch(err => { });
      //获取报表累计信息列表
      monthBizContent.pageQueryDto = {
        start: 0,
        limit: 50
      }
      response(requstsMethod.fun_Get_Report_List_Detail_Account, monthBizContent)
        .then(data => {
          console.log(data, '当月报表累计信息')
          this.totalAmountList = [];
          this.actualAmountList = [];
          this.onLineIncomeList = [];
          this.unLineIncomeList = [];
          this.tableIncomeList = [];
          this.goodsIncomeList = [];
          this.vipAmountList = [];
          this.waterIncomeList = [];
          this.dateList = [];
          let { dataList } = data
          dataList.forEach(item => {
            if (!item.realAmount) item.realAmount = 0;
            //预定
            if (!item.reserveAmount) item.reserveAmount = 0;
            //商品
            if (!item.goodsAmount) item.goodsAmount = 0;
            //报名
            if (!item.signAmount) item.signAmount = 0;
            //会员充值
            if (!item.vipAmount) item.vipAmount = 0;
            //线下商品
            if (!item.goodsUnlineAmount) item.goodsUnlineAmount = 0;
            //线下球桌
            if (!item.realUnlineAmount) item.realUnlineAmount = 0;
            //会员消费
            if (!item.otherAmount) item.otherAmount = 0;
            //销账金额
            if (!item.writeOffAmount) item.writeOffAmount = 0;
            //免单金额
            if (!item.freeSheetAmount) item.freeSheetAmount = 0;
            //娃娃机金额
            if (!item.toyAmount) item.toyAmount = 0;
            //水机金额
            if (!item.waterAmount) item.waterAmount = 0;
            var dateArray = item.day.substring(0, 11).split("-")
            var date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
            var dateDay = date.getDay()
            switch (dateDay) {
              case 1:
                item.dateDay = '周一'
                item.bg_color = false;
                break;
              case 2:
                item.dateDay = '周二'
                item.bg_color = false;
                break;
              case 3:
                item.dateDay = '周三'
                item.bg_color = false;
                break;
              case 4:
                item.dateDay = '周四'
                item.bg_color = false;
                break;
              case 5:
                item.dateDay = '周五'
                item.bg_color = false;
                break;
              case 6:
                item.dateDay = '周六'
                item.bg_color = true;
                break;
              case 0:
                item.dateDay = '周日'
                item.bg_color = true;
                break;
            }
            item.day = item.day.substring(5, 11);
            item.onLineIncome =   //线上收入
              item.realAmount +         //球桌收入
              item.goodsAmount +      //商品收入
              item.vipAmount +        //会员充值收入
              item.signAmount +       //报名收入
              item.reserveAmount +     //预定收入
              item.toyAmount +       //娃娃机收入
              item.waterAmount      //水机收入
            item.unLineIncome =   //线下收入
              item.goodsUnlineAmount + //商品收入
              item.realUnlineAmount  //球桌收入
            item.goodsIncome = item.goodsAmount + item.goodsUnlineAmount;  //商品总收入
            item.realIncome = item.realAmount + item.realUnlineAmount;     //球桌总收入
            item.allIncome = item.onLineIncome + item.unLineIncome  //实际收入
            item.freeIncome = item.otherAmount + item.writeOffAmount + item.freeSheetAmount  //虚收
            item.totalAmount = item.allIncome + item.freeIncome  //总营业额
            this.totalAmountList.push(item.totalAmount);
            this.actualAmountList.push(item.allIncome);
            this.onLineIncomeList.push(item.onLineIncome);
            this.unLineIncomeList.push(item.unLineIncome);
            this.tableIncomeList.push(item.realIncome);
            this.goodsIncomeList.push(item.goodsIncome);
            this.vipAmountList.push(item.vipAmount);
            this.waterIncomeList.push(item.waterAmount);
            this.dateList.push(item.day);
            //访客如果不存在就给0
            if (!item.totalCount) {
              item.totalCount = 0
            }
            //总访客数
            if (!dataList.allTotalcount) dataList.allTotalcount = 0
            dataList.allTotalcount += item.totalCount
            parseInt(dataList.allTotalcount)
            //当月总报名收入
            if (!dataList.allSignIncome) dataList.allSignIncome = 0
            dataList.allSignIncome += item.signAmount
            //当月总预定收入
            if (!dataList.allReserveAmount) dataList.allReserveAmount = 0
            dataList.allReserveAmount += item.reserveAmount
            //当月总充值收入
            if (!dataList.allVipAmount) dataList.allVipAmount = 0
            dataList.allVipAmount += item.vipAmount
            //当月总商品收入
            if (!dataList.allGoodsIncome) dataList.allGoodsIncome = 0
            dataList.allGoodsIncome += item.goodsIncome
            //当月总球桌收入
            if (!dataList.allRealIncome) dataList.allRealIncome = 0
            dataList.allRealIncome += item.realIncome
            //当月总收入
            if (!dataList.allAllIncome) dataList.allAllIncome = 0
            dataList.allAllIncome += item.allIncome
            //当月总线下收入
            if (!dataList.allUnLineIncome) dataList.allUnLineIncome = 0
            dataList.allUnLineIncome += item.unLineIncome
            //当月总线下收入
            if (!dataList.allOnLineIncome) dataList.allOnLineIncome = 0
            dataList.allOnLineIncome += item.onLineIncome
            //当月总营业额
            if (!dataList.allToltalAmount) dataList.allToltalAmount = 0
            dataList.allToltalAmount += item.totalAmount
            //当月水机总收入
            if (!dataList.allWaterAmount) dataList.allWaterAmount = 0
            dataList.allWaterAmount += item.waterAmount
          })
          this.totalAmountList = this.totalAmountList.reverse().map(item => Math.floor(item));
          this.actualAmountList = this.actualAmountList.reverse().map(item => Math.floor(item));
          this.onLineIncomeList = this.onLineIncomeList.reverse().map(item => Math.floor(item));
          this.unLineIncomeList = this.unLineIncomeList.reverse().map(item => Math.floor(item));
          this.tableIncomeList = this.tableIncomeList.reverse().map(item => Math.floor(item));
          this.goodsIncomeList = this.goodsIncomeList.reverse().map(item => Math.floor(item));
          this.vipAmountList = this.vipAmountList.reverse().map(item => Math.floor(item));
          this.waterIncomeList = this.waterIncomeList.reverse().map(item => Math.floor(item));
          this.dateList = this.dateList.reverse();
          this.statisticsData = this.totalAmountList;
          this.tableData = dataList;
          console.log(this.tableData, '处理后')
        })
    },
    showInfocb () {
      this.isShowInfo = false;
    },
    showDrawer (e) {
      switch (e) {
        case 0:
          this.isDrawer = e;
          this.currentName = 'totalTurnover';  //总营业额
          break;
        case 1:
          this.isDrawer = e;
          this.currentName = 'reportTable';  //球桌
          break;
        case 2:
          this.isDrawer = e;
          this.currentName = 'reportGoods';  //商品
          break;
        case 3:
          this.isDrawer = e;
          this.currentName = 'reportChange';  //充值
          break;
        case 4:
          // this.isDrawer = e;
          // this.currentName = 'reportSign';  //报名
          break;
        case 5:
          // this.isDrawer = e;
          // this.currentName = 'reportReserve';  //预定
          break;
        case 6:
          // this.isDrawer = e;
          // this.currentName = 'reportAssistant';  //助教
          break;
        case 7:
          // this.isDrawer = e;
          // this.currentName = 'reportDoll';  //娃娃机
          break;
      }
    },
    closeInfo () {
      this.isDrawer = -1;
    },
    addShadow (e) {
      let itemShadow = this.$refs.shadow
      let liShadow = this.$refs.liShadow
      let columnShadow = this.$refs.columnShadow
      let number = this.queryClassName(e, 'move-shadow')
      let boxNumber = this.queryClassName(e, 'report-right-top')
      // console.log(number,boxNumber,'我可以拿到我想要的数字')
      if (typeof (number) != "undefined") {
        let titleNumber = this.queryClassNameTemp(e, boxNumber, 'report-title')
        // console.log(titleNumber,'拿到的数字')
        itemShadow.style.display = 'block';
        liShadow.style.display = 'none';
        columnShadow.style.display = 'block';
        // console.log(e,'事件对象')
        if (number == 1) {
          if (e.path[number].children[2].innerText == '日期' || e.path[number].children[2].innerText == '周期') {
            itemShadow.style.display = 'none';
            columnShadow.style.display = 'none';
          }
          columnShadow.name = e.path[number].children[2].innerText
        }
        columnShadow.style.width = e.path[number].clientWidth + 'px'
        columnShadow.style.height = (e.path[boxNumber].clientHeight - e.path[boxNumber].children[titleNumber].clientHeight - 5) + 'px'
        columnShadow.style.top = e.path[number].offsetTop + 'px'
        columnShadow.style.left = e.path[number].offsetLeft + 'px'
        itemShadow.style.width = e.path[number].clientWidth + 'px'
        itemShadow.style.height = e.path[number].clientHeight + 'px'
        itemShadow.style.top = e.path[number].offsetTop + 'px'
        itemShadow.style.left = e.path[number].offsetLeft + 'px'
        if (number == 0) {
          // console.dir(e.path[number].offsetParent,'选中的li')
          // console.log(liShadow)
          itemShadow.style.display = 'none';
          liShadow.style.display = 'block';
          columnShadow.style.display = 'none';
          // liShadow.style.width = e.path[number].offsetParent.clientWidth + 'px'
          // liShadow.style.height = e.path[number].offsetParent.clientHeight + 'px'
          // liShadow.style.top = e.path[number].offsetParent.offsetTop + 'px'
          // liShadow.style.left = e.path[number].offsetParent.offsetLeft + 'px'
          // itemShadow.style.top = (e.path[number].offsetParent.offsetParent.offsetTop + e.path[number].offsetParent.offsetTop) + 'px'
          // itemShadow.style.left = (e.path[number].offsetLeft + e.path[number].offsetParent.offsetParent.offsetLeft + e.path[number].offsetParent.offsetLeft) + 'px'
        }
      }
    },
    queryClassName (e, name) {
      for (let i = 0; i < e.path.length; i++) {
        let text = e.path[i].className
        if (typeof (text) != "undefined") {
          if (text.indexOf(name) != -1) return i
        }
      }
    },
    queryClassNameTemp (e, boxNumber, name) {
      for (let i = 0; i < e.path[boxNumber].children.length; i++) {
        let text = e.path[boxNumber].children[i].className
        if (typeof (text) != "undefined") {
          if (text.indexOf(name) != -1) return i
        }
      }
    },
    clickList (e) {
      this.name = e.srcElement.name;
      switch (e.srcElement.name) {
        case '总营业额':
          this.statisticsData = this.totalAmountList;
          break;
        case '实际收入':
          this.statisticsData = this.actualAmountList;
          break;
        case '线上收入':
          this.statisticsData = this.onLineIncomeList;
          break;
        case '线下收入':
          this.statisticsData = this.unLineIncomeList;
          break;
        case '球台':
          this.statisticsData = this.tableIncomeList;
          break;
        case '商品':
          this.statisticsData = this.goodsIncomeList;
          break;
        case '充值':
          this.statisticsData = this.vipAmountList;
          break;
        case '自助商品':
          this.statisticsData = this.waterIncomeList;
          break;
      }
    }
  },
  computed: {
    //首页当日统计数据计算
    //线上+线下商品的收入
    goodsIncome: function () {
      if (!this.returnData.billiardsStatementAccountTotalDetailed.goodsUnlineAmount) {
        this.returnData.billiardsStatementAccountTotalDetailed.goodsUnlineAmount = 0
      }
      return this.returnData.billiardsStatementAccountTotalDetailed.goodsAmount + //线上商品收入
        this.returnData.billiardsStatementAccountTotalDetailed.goodsUnlineAmount   //线下商品收入
    },
    //线上+线下商品的单数
    goodsNumber: function () {
      if (!this.returnData.billiardsStatementAccountTotalDetailed.goodsUnlineCount) {
        this.returnData.billiardsStatementAccountTotalDetailed.goodsUnlineCount = 0
      }
      return this.returnData.billiardsStatementAccountTotalDetailed.goodsCount + //线上商品单数
        this.returnData.billiardsStatementAccountTotalDetailed.goodsUnlineCount   //线下商品单数
    },
    //线上+线下球桌的收入
    tableIncome: function () {
      if (!this.returnData.billiardsStatementAccountTotalDetailed.realUnlineAmount) {
        this.returnData.billiardsStatementAccountTotalDetailed.realUnlineAmount = 0
      }
      return this.returnData.billiardsStatementAccountTotalDetailed.realAmount + //线上球桌收入
        this.returnData.billiardsStatementAccountTotalDetailed.realUnlineAmount   //线下球桌收入
    },
    //线上+线下球桌的单数
    tableNumber: function () {
      if (!this.returnData.billiardsStatementAccountTotalDetailed.realUnlineCount) {
        this.returnData.billiardsStatementAccountTotalDetailed.realUnlineCount = 0
      }
      return this.returnData.billiardsStatementAccountTotalDetailed.realCount + //线上球桌单数
        this.returnData.billiardsStatementAccountTotalDetailed.realUnlineCount   //线下球桌单数
    },
    //线上+线下的实际收入
    realIncome: function () {
      return this.goodsIncome + //线上+线下商品的收入
        this.tableIncome + //线上+线下球桌的收入
        this.returnData.billiardsStatementAccountTotalDetailed.vipAmount + //会员充值的收入
        this.returnData.billiardsStatementAccountTotalDetailed.signAmount + //报名收入
        this.returnData.billiardsStatementAccountTotalDetailed.reserveAmount + //预定收入
        this.returnData.billiardsStatementAccountTotalDetailed.toyAmount +   //娃娃机收入
        this.returnData.billiardsStatementAccountTotalDetailed.waterAmount   //水机收入
      //  this.returnData.billiardsStatementAccountTotalDetailed.   //助教收入  暂时没有先放着
    },
    //线上+线下的实收单数
    realNumber: function () {
      return this.goodsNumber + //线上+线下商品的单数
        this.tableNumber + //线上+线下球桌的单数
        this.returnData.billiardsStatementAccountTotalDetailed.vipCount + //会员充值单数
        this.returnData.billiardsStatementAccountTotalDetailed.signCount + //报名单数
        this.returnData.billiardsStatementAccountTotalDetailed.reserveCount + //预定单数
        this.returnData.billiardsStatementAccountTotalDetailed.toyCount +   //娃娃机单数
        this.returnData.billiardsStatementAccountTotalDetailed.waterCount   //水机单数
      //  this.returnData.billiardsStatementAccountTotalDetailed.  //助教单数   暂时没有先放着
    },
    //虚收总金额
    grossIncome: function () {
      //先判断会员结账金额字段是否存在
      if (!this.returnData.billiardsStatementAccountTotalDetailed.otherAmount) {
        this.returnData.billiardsStatementAccountTotalDetailed.otherAmount = 0
      }
      return this.returnData.billiardsStatementAccountTotalDetailed.otherAmount + //会员结账金额
        this.returnData.billiardsStatementAccountTotalDetailed.freeSheetAmount + //免单金额
        this.returnData.billiardsStatementAccountTotalDetailed.writeOffAmount   //销账金额
    },
    //虚收总单数
    grossNumber: function () {
      //先判断会员结账单数字段是否存在
      if (!this.returnData.billiardsStatementAccountTotalDetailed.otherCount) {
        this.returnData.billiardsStatementAccountTotalDetailed.otherCount = 0
      }
      return this.returnData.billiardsStatementAccountTotalDetailed.otherCount + //会员结账单数
        this.returnData.billiardsStatementAccountTotalDetailed.freeSheetCount + //免单单数
        this.returnData.billiardsStatementAccountTotalDetailed.writeOffCount   //销账单数
    },
    //总营业额
    totalTurnover: function () {
      return this.realIncome + //线上+线下实际收入
        this.grossIncome  //虚收总金额
    }
  },
  watch: {
    timeSlotValue (val, oldVal) {
      if (val == null) this.timeSlotValue = [];
    }
  },
  created () {
    this.initData()
    console.log(this.$route, '旧报表router');
  }
};
</script>

<style lang="scss" scoped>
.report-open-content {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Heavy;
  font-weight: 800;
  text-align: center;
  color: #ffffff;
  position: relative;
  height: 100%;
  // margin-left: 8px;
  // margin-top: 9px;
  background: #4d4d4d;
  box-shadow: 2px 2px 5px inset #000;

  li {
    list-style: none;
  }

  .report-content {
    height: 100%;
    overflow: hidden;

    .report-left {
      width: 500px;
      margin: 8px;
      height: calc(100% - 16px);
      padding: 8px;
      background: #3e3e3e;
      box-shadow: 0px 0px 5px #000;
      float: left;

      .report-left-flex {
        height: calc(((100% - 130px) / 15 * 6) + 30px);
        display: flex;
        justify-content: space-between;
        clear: both;
        margin-bottom: 18px;

        .report-left-left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: calc((100% - 6px) / 2);

          > div {
            height: calc((100% - 30px) / 6);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 8px;
            border-radius: 2px;
            box-shadow: 2px 2px 5px #000 inset, -2px -2px 5px #000 inset;
          }
        }

        .report-left-right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: calc((100% - 6px) / 2);

          > div {
            height: calc((100% - 30px) / 6);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 8px;
            border-radius: 2px;
            box-shadow: 2px 2px 5px #000 inset, -2px -2px 5px #000 inset;
          }
        }
      }

      .first-floor {
        height: calc((100% - 130px) / 15);
        line-height: 30px;
        font-size: 16px;
        margin-bottom: 6px;
        box-shadow: 2px 2px 5px #000 inset, -2px -2px 5px #000 inset;
        padding: 0 8px;
        border-radius: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > span {
          text-align: right;
        }

        .small-size {
          font-size: 12px;
        }
      }

      .last-item {
        margin-bottom: 18px;
      }

      .blue {
        background: #039fff;
      }

      .red {
        background: #cc3030;
      }

      .orange {
        background: #d97d11;
      }

      .brown {
        background: #935812;
      }

      .yellow {
        background: #a5a811;
      }

      .green {
        background: #666811;
      }

      .white {
        background: #fff;
      }

      .crossing:hover {
        box-shadow: 0px 0px 10px #2afeb2 inset !important;
        background: rgba(42, 254, 178, 0.1);
      }

      .pointer {
        cursor: pointer;
      }
    }

    .report-right {
      width: calc(100% - 524px);
      height: calc(100% - 16px);
      float: left;
      overflow: visible;
      margin-top: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .report-right-top {
        position: relative;
        height: 65.5226%;
        box-shadow: 0px 0px 5px #000;
        background: #3e3e3e;
        padding: 0 7px 7px;

        .add-shadow {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          border-radius: 6px;
          box-shadow: 2px 2px 4px #2afeb2 inset, -2px -2px 4px #2afeb2 inset;
          transition: all 0.2s;
        }

        .column-shadow {
          display: none;
          position: absolute;
          height: 0;
          top: 0;
          left: 0;
          z-index: 10;
          border-radius: 6px;
          box-shadow: 2px 2px 4px #2afeb2 inset, -2px -2px 4px #2afeb2 inset;
          transition: all 0.2s;
          cursor: pointer;
        }

        .report-title {
          color: #00fe99;
          text-align: left;
          padding-left: 11px;
          line-height: 44px;
        }

        .report-surface-header {
          height: 69px;
          display: flex;
          justify-content: space-between;
          padding: 0 11px;

          > div {
            position: relative;
            width: calc(100% / 11);
            height: 100%;
            display: flex;
            justify-content: space-evenly;
            flex-direction: column;

            > p {
              height: 20px;
              line-height: 20px;
              font-size: 14px;
            }
          }
        }

        .report-surface {
          background: #2b2b2b;
          height: calc(100% - 113px);
          box-shadow: 2px 2px 5px #000 inset, -2px -2px 5px #000 inset;

          .report-surface-list {
            padding: 5px 11px 0;

            .add-li-shadow {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 10;
              border-radius: 2px;
              box-shadow: 2px 2px 4px #2afeb2 inset, -2px -2px 4px #2afeb2 inset;
              transition: all 0.2s;
            }

            > li {
              position: relative;
              list-style: none;
              margin-bottom: 5px;
              height: 30px;
              line-height: 30px;
              display: flex;
              justify-content: space-between;
              border-radius: 2px;
              box-shadow: 0px 0px 5px #000;

              > p {
                position: relative;
                width: calc(100% / 11);
              }
            }

            > li:hover {
              box-shadow: 1px 1px 5px #2affb2 inset, -1px -1px 5px #2affb2 inset;
            }

            .bg_item1 {
              background: #3e3e3e;
            }

            .bg_item2 {
              background: #626262;

              .yellow-green {
                opacity: 0.5;
              }
            }
          }
        }
      }

      .report-right-bottom {
        height: 33.2293%;
        box-shadow: 0px 0px 5px #000;
        background: #3e3e3e;
      }

      .yellow-green {
        //黄绿色
        color: #beffaa;
      }

      .emerald-green {
        //翡翠绿
        color: #64ffb3;
      }

      .ashen {
        //土色
        color: #ffaf61;
      }

      .pink {
        //粉色
        color: #ff0095;
      }

      .fluorescein {
        //橘黄
        color: #ffc344;
      }

      .yellow {
        //黄色
        color: #ffdd00;
      }

      .violet {
        //紫色
        color: #72b3ff;
      }

      .wathet {
        //浅蓝色
        color: #00ffed;
      }

      .green {
        //绿色
        color: #00fe1c;
      }

      .bright-red {
        //红色
        color: #ff6464;
      }

      .blue {
        color: #44cfff;
      }
    }
  }

  .middleList {
    width: 403px;
    height: 634px;
    position: absolute;
    top: 69px;
    left: 339px;
    background: #3e3e3e;
    border-radius: 4px;
    box-shadow: 3px 3px 7px#000, -1px -1px 5px #000;
    color: #ffffff;
    font-size: 16px;
    font-weight: 900;

    .middleList-title {
      width: 386px;
      height: 40px;
      margin: auto;
      line-height: 40px;
      background: #16bf59;
      border-radius: 4px;
      margin-top: 8px;
      box-shadow: 3px 3px 5px #000;
    }

    .middleList-tableBar {
      display: flex;
      justify-content: space-between;
      line-height: 40px;
      margin: 8px 8px 0;

      div {
        width: 123px;
        height: 40px;
        border-radius: 4px;
        background: #0c6630;
        cursor: pointer;
        box-shadow: 2px 2px 5px #000, -1px -1px 5px #000;
      }

      .active {
        background: #16bf59;
      }
    }

    .content {
      margin-top: 8px;
      height: calc(634px - 110px);

      .el-scrollbar__wrap {
        overflow-x: hidden;
      }

      .item {
        text-align: left;
        position: relative;
        width: 386px;
        height: 30px;
        line-height: 30px;
        margin: auto;
        margin-bottom: 8px;
        background: #4d4d4d;
        border-radius: 4px;
        box-shadow: 2px 2px 5px #000, -2px -2px 5px #000;

        .item_left {
          position: absolute;
          top: 0;
          z-index: 1;
        }

        .item_right {
          right: 24px;
          position: absolute;
          z-index: 1;
        }

        .item_rt {
          position: absolute;
          right: -28px;
          top: 0;
          margin-top: 5px;
          border-width: 10px;
          border-style: solid;
          border-color: transparent transparent transparent #fff;
        }

        :nth-child(1) {
          margin-left: 8px;
        }

        :nth-child(3) {
          float: right;
          margin-right: 25px;
        }

        .item_bg {
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 4px;
          background: #16bf59;
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  .lastList {
    width: 403px;
    height: 636px;
    position: absolute;
    top: 69px;
    left: 750px;
    background: #3e3e3e;
    border-radius: 4px;
    box-shadow: 3px 3px 7px#000, -1px -1px 5px #000;
    color: #ffffff;
    font-size: 16px;
    font-weight: 900;

    .lastList-title {
      width: 386px;
      height: 40px;
      margin: auto;
      line-height: 40px;
      background: #16bf59;
      border-radius: 4px;
      margin-top: 8px;
      box-shadow: 3px 3px 5px #000;
    }

    .lastList-tableBar {
      display: flex;
      justify-content: space-between;
      line-height: 40px;
      margin: 8px 8px 0;

      div {
        width: 123px;
        height: 40px;
        border-radius: 4px;
        background: #0c6630;
        cursor: pointer;
      }

      .active {
        background: #16bf59;
      }
    }
  }

  ::v-deep.select-time {
    position: absolute;
    top: -38px;
    right: 0;
    widows: 694px;
    font-size: 20px;
    line-height: 30px;
    display: flex;
    justify-content: flex-end;

    .query-number-title {
      text-align: left;
      font-size: 14px;
      //margin: 0 20px;
    }

    .query-number-input {
      .el-input__inner {
        font-size: 20px;
        padding: 0;
        padding-left: 20px;
        color: rgba(203, 203, 203, 1);
      }
    }

    .query-btn {
      width: 80px;
      height: 30px;
      background: #ff8b3e;
      color: #fff;
      font-size: 16px;
      line-height: 30px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 2px;
      box-shadow: 0px 0px 5px #000;
    }

    .query-bill-btn {
      //float: right;
      width: 116px;
      height: 30px;
      background: #ff8b3e;
      line-height: 30px;
      text-align: center;
      border-radius: 2px;
      font-size: 16px;
      font-weight: 900;
      margin-right: 10px;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      box-shadow: 0px 0px 5px #000;
    }

    .query-bill-data-btn {
      width: 148px;
      background: #ff8b3e;
      line-height: 30px;
      height: 30px;
      margin-right: 20px;
      color: rgba(255, 255, 255, 1);
      font-weight: 900;
      cursor: pointer;
      font-size: 16px;
      border-radius: 2px;
      box-shadow: 0px 0px 5px #000;
    }

    // .el-range-editor.el-input__inner{
    //     padding: 0;
    //   }
    .query-total {
      margin-right: 10px;

      .el-date-editor {
        width: 300px !important;
        height: 30px;
        padding: 0;
        border: none;
        border-radius: 2px;
        box-shadow: 0px 0px 5px #000;
        background: #626262;

        .el-range__icon {
          font-size: 25px;
          margin-left: 15px;
          line-height: 30px;
        }

        .el-range-input {
          font-size: 16px;
          color: #fff;
          width: 100px;
          background: #626262;
        }

        .el-range-separator {
          width: 20px;
          padding: 0;
          margin: 0 10px;
          font-size: 16px;
          line-height: 30px;
          color: #fff;
        }

        .el-range__close-icon {
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
  }

  .report-open-body {
    width: 323px;
    margin-top: 8px;
    padding-bottom: 8px;
    background-color: #3d3d3d;
    height: calc(100% - 74px);
    box-shadow: 2px 2px 5px #000;

    .report-open-left {
      // float: left;
      // width: calc(100% - 20px);
      // height: 100%;
      .report-open-up-total {
        // width: 323px;
        overflow: hidden;

        :nth-child(2) {
          .item-table-info-title-row-left {
            color: #9eedff;

            .item-table-info-title-row-number {
              color: #9eedff;
            }
          }

          .item-table-info-title-row-right {
            color: #9eedff;

            .item-table-info-title-row-number {
              color: #9eedff;
            }

            .item_rt {
              border-color: transparent transparent transparent #9eedff;
            }
          }
        }

        .report-open-up-total-left {
          // float: left;
          margin-left: 8px;
          margin-right: 8px;
          // width: calc(25% - 10px);
          // height: 120px;
          padding-top: 10px;
          //background: #fb4447;
          border-radius: 4px;

          .el-dialog__wrapper {
            background-color: rgba(0, 0, 0, 0.3);

            .el-dialog {
              background: rgba(0, 0, 0, 0);
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
              margin: 0;

              .el-dialog__header {
                padding: 0;
              }

              .el-dialog__title {
                padding: 0;
              }

              .el-dialog__body {
                margin-left: 206px;

                .triangle-up {
                  margin-left: 20px;
                  width: 0;
                  height: 0;
                  border-left: 8px solid transparent;
                  border-right: 8px solid transparent;
                  border-bottom: 16px solid rgba(247, 245, 241, 1);
                }

                .question-mark-content {
                  margin-top: -1px;
                  width: 520px;
                  height: 66px;
                  background: #f7f5f1;
                  border-radius: 10px;
                  padding-left: 10px;

                  div {
                    padding-top: 10px;
                    text-align: left;
                  }

                  em {
                    font-style: normal;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: left;
                    color: #fb4447;
                  }

                  i {
                    font-style: normal;
                    font-size: 16px;
                    font-weight: 300;
                    text-align: left;
                    color: #fb4447;
                  }
                }
              }
            }
          }
        }

        .report-open-up-total-right {
          //float: left;
          //width: calc(75% - 10px);
          width: 432px;
          padding: 10px 10px 0 10px;
          // height: 120px;
          //padding-top: 10px;
          border-radius: 4px;

          //display: flex;
          .item_rt {
            position: absolute;
            right: -28px;
            margin-top: 10px;
            border-width: 10px;
            border-style: solid;
            border-color: transparent #fff transparent transparent;
            transform: rotate(180deg);
            /*顺时针旋转90°*/
          }

          .total-item-content {
            background-color: rgba(255, 58, 58, 0.5);
          }
        }
      }
    }

    .report-open-right {
      float: right;
      margin-right: 10px;
      width: 340px;
      height: 707px;
      border-radius: 4px;
      background: rgba(247, 247, 247, 1);

      .report-open-right-title {
        width: 340px;
        height: 150px;
        border-radius: 4px 4px 0 0;
        background: rgba(247, 179, 90, 1);
        color: rgba(255, 255, 255, 1);

        .report-open-right-left {
          float: left;
          width: 170px;
        }

        .report-open-right-right {
          float: left;
          width: 170px;
        }

        .report-open-title {
          font-size: 20px;
          font-weight: 300;
          padding-top: 30px;
        }

        .report-open-number {
          padding-top: 20px;
          line-height: 54px;
          font-size: 36px;
          font-weight: 700;
        }
      }

      .report-open-right-body {
        .report-open-right-body-item {
          height: 50px;
          line-height: 50px;
          background: rgba(247, 247, 247, 1);
          font-size: 20px;
          font-weight: 500;
          color: rgba(66, 66, 66, 1);
          border-bottom: 1px solid #e2e2e2;

          .report-open-right-body-item-left {
            width: 120px;
            border-right: 1px solid #e2e2e2;
            float: left;
          }

          .report-open-right-body-item-right {
            width: 218px;
            float: left;
          }
        }
      }
    }
  }

  .report-open-dn {
    width: 323px;
    display: flex;
    flex-direction: column;
    background: #3e3e3e;
    padding: 10px 0;
    border-radius: 4px;
    box-shadow: 2px 2px 5px #000;

    .visitor {
      margin: 10px 8px 0;
      height: 30px;
      line-height: 30px;
      background: #039fff;
      border-radius: 4px;
      font-size: 16px;
      color: #222222;
      overflow: hidden;
      cursor: pointer;

      .left {
        padding-left: 10px;
        float: left;
        font-weight: 900;

        .txt {
          margin-right: 10px;
        }
      }

      .right {
        float: right;
        margin-top: 5px;
        margin-right: -5px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent transparent transparent #222222;
      }
    }

    .item-info-background-color {
      .item-info-title {
        background: rgba(12, 165, 241, 1);
      }
    }

    .report-open-up-total-left {
      margin: 0 8px 1px;

      .report-open-up-total-left-txt {
        color: #2affb2;
        text-align: left;
        text-indent: 10px;
        font-size: 18px;
      }
    }
  }

  .report-open-bottom {
    margin-top: 8px;
    width: 323px;
    overflow: hidden;
    padding-bottom: 10px;
    background: #3e3e3e;
    box-shadow: 2px 2px 5px #000;

    .color:nth-child(1) {
      .item-table-info-title {
        .item-table-info-title-row {
          color: #ff923a;
          font-weight: 700;

          .item-table-info-title-row-number {
            color: #ff923a;
            font-weight: 700;
          }
        }
      }
    }

    .color:nth-child(2) {
      .item-table-info-title {
        .item-table-info-title-row {
          color: #ff5555;
          font-weight: 700;

          .item-table-info-title-row-number {
            color: #ff5555;
            font-weight: 700;
          }
        }
      }
    }
  }
}

.clear-border-right {
  border-right: 0px solid #e8e6e2 !important;
}

.report-open-up-total-left2 {
  margin: 0 10px;
  background: #ff004e;
  cursor: pointer;
}

.look-every-day-info {
  position: absolute;
  top: 0;
}

.item-table-info-content {
  margin: 10px 8px 0;
  text-align: left;

  .item-table-info-title {
    position: relative;
    width: 100%;

    .item_rt {
      margin-top: 5px;
      float: right;
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent transparent #eaeaea;
    }

    .bg_item {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 0%;
      height: 100%;
      border-radius: 4px;
      // transition-property: width;
      // transition-duration: 1s;
    }

    .item-table-info-title-row {
      overflow: hidden;
      display: flex;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      background: #4d4d4d;
      font-weight: 900;
      text-align: left;
      color: #eaeaea;
      cursor: pointer;

      //padding-top: 8px;
      .item-table-info-title-row-left {
        position: absolute;
        left: 0px;
        top: 0px;
        flex: 1;
        //text-align: center;
        padding-left: 10px;
        z-index: 10;

        .item-table-info-title-row-content {
          //width: 100%;
          //height: 100%;
          margin: 0 auto;
        }
      }

      .item-table-info-title-row-right {
        position: absolute;
        right: -4px;
        top: 0px;
        z-index: 10;
        flex: 1;
        height: 30px;
        line-height: 30px;
        text-align: right;
      }

      .item-table-info-title-row-text {
        //float: left;
        margin-right: 10px;
      }

      .item-table-info-title-row-number {
        //float: left;
        //margin-left: 20px;
        font-weight: 900;
        //text-align: left;
        color: #eaeaea;
      }
    }
  }
}
</style>